<template>
  <BaseDialog v-bind="$attrs" v-model="showDialog">
    <ClientNotificationEditForm
      ref="editForm"
      v-bind="$props"
      class="mt-n4"
      @cancel="close"
      @create="create"
      @update="update"
    />
  </BaseDialog>
</template>

<script>
import baseDialogMixin from '@/services/baseDialogMixin';
import ClientNotificationEditForm from './ClientNotificationEditForm';
export default {
  mixins: [baseDialogMixin],
  components: {
    ClientNotificationEditForm,
  },
  props: ['id', 'data'],
  data() {
    return {};
  },
  methods: {
    close() {
      this.showDialog = false;
    },
    create(model) {
      this.$emit('create', model);
    },
    update(model) {
      this.$emit('update', model);
    },
  },
};
</script>

<style lang="scss" scoped></style>
